class Modal {
	static setDefaults(opts = {}) {
		window.modalDefaultOptions = opts;
	}

	static getDefault(property) {
		if (!window.modalDefaultOptions) {
			return false;
		}

		return Object.prototype.hasOwnProperty.call(window.modalDefaultOptions, property)
			? window.modalDefaultOptions[property]
			: false;
	}

	static show(opts = {}) {
		const backdrop = document.querySelector('.modal__backdrop') || Modal.createMarkup();
		const container = backdrop.querySelector('.modal__container');
		const content = backdrop.querySelector('.modal__content');
		const closeButton = backdrop.querySelector('.modal__close-button');

		const modalId = Date.now();

		container.setAttribute('id', modalId);
		container.setAttribute('class', 'modal__container');

		if (opts.containerClass) {
			container.classList.add(opts.containerClass);
		}

		content.innerHTML = opts.content || 'no content specified';

		backdrop.removeEventListener('click', Modal.backdropClicked);
		closeButton.removeEventListener('click', Modal.close);
		window.removeEventListener('keyup', Modal.keyupListener);

		closeButton.addEventListener('click', Modal.close);

		if (!Object.prototype.hasOwnProperty.call(opts, 'closeOnClick') || opts.closeOnClick) {
			backdrop.addEventListener('click', Modal.backdropClicked);
		}

		if (!Object.prototype.hasOwnProperty.call(opts, 'closeOnEscape') || opts.closeOnEscape) {
			window.addEventListener('keyup', Modal.keyupListener);
		}

		if (Object.prototype.hasOwnProperty.call(opts, 'onClose') && typeof opts.onClose === 'function') {
			if (typeof window.modalCloseHandlers === 'undefined' || typeof window.modalCloseHandlers !== 'object') {
				window.modalCloseHandlers = {};
			}

			window.modalCloseHandlers[modalId] = opts.onClose;
		}

		backdrop.setAttribute('data-close-timeout', opts.contentRemoveDelay || Modal.getDefault('contentRemoveDelay') || 0);

		setTimeout(() => {
			backdrop.classList.add('active');
			document.querySelector('html').classList.add('modal-active');

			if (Object.prototype.hasOwnProperty.call(opts, 'onOpen') && typeof opts.onOpen === 'function') {
				opts.onOpen(container);
			}
		}, 1);

		return modalId;
	}

	static backdropClicked(e) {
		if (e.target.classList.contains('modal__backdrop')) {
			Modal.close();
		}
	}

	static keyupListener(e) {
		if (e.keyCode === 27) {
			Modal.close();
		}
	}

	static createMarkup() {
		const backdrop = document.createElement('div');
		backdrop.classList.add('modal__backdrop');

		backdrop.innerHTML = `
			<div class="modal__container">
				<button class="modal__close-button">✕</button>
				<div class="modal__content"></div>
			</div>
		`;

		document.body.appendChild(backdrop);

		return document.querySelector('.modal__backdrop');
	}

	static close() {
		const backdrop = document.querySelector('.modal__backdrop');

		if (!backdrop) {
			return;
		}

		const container = backdrop.querySelector('.modal__container');
		const modalId = container.getAttribute('id');
		const closeTimeout = backdrop.getAttribute('data-close-timeout') || 0;

		backdrop.classList.remove('active');
		document.querySelector('html').classList.remove('modal-active');

		if (window.modalCloseHandlers && window.modalCloseHandlers[modalId]) {
			const closeFunc = window.modalCloseHandlers[modalId];

			if (typeof closeFunc === 'function') {
				closeFunc(container);
			}
		}

		setTimeout(() => {
			const modalContent = backdrop.querySelector('.modal__content');

			while (modalContent.firstChild) {
				modalContent.removeChild(modalContent.firstChild);
			}
		}, closeTimeout);
	}
}

export default Modal;
